// extracted by mini-css-extract-plugin
export var banner = "_nu-0";
export var settingRow = "_nu-2";
export var titleIcon = "_nu-1";